import { Component, Input } from '@angular/core';
import { FormControl } from '@angular/forms';
import { IconDefinition } from '@fortawesome/pro-regular-svg-icons';

@Component({
  selector: 'eiq-display-toggle-buttons',
  templateUrl: './display-toggle-buttons.component.html',
  styleUrls: ['./display-toggle-buttons.component.scss']
})
export class DisplayToggleButtonsComponent {
  @Input() displayControl: FormControl;
  @Input() statusList: { value: number; icon?: IconDefinition }[];
}
